export const DESIGN_SYSTEM = 'Design System';
export const ATOMS = `${DESIGN_SYSTEM}|Atoms`;
export const MOLECULES = `${DESIGN_SYSTEM}|Molecules`;
export const ORGANISMS = `${DESIGN_SYSTEM}|Organisms`;
